module.exports = __webpack_public_path__ + "static/media/donate-red-kn.c396e7aa.svg";